import { animate, group, query, style, transition, trigger } from "@angular/animations";

// Animation trigger name to be used on the component
export const SlideAnimationTrigger = "slideAnimation";

// Key is passed to the animation trigger to determine if the animation should be applied
export const SlideAnimationPageKey = "slidePage";

export const slideAnimation = trigger(SlideAnimationTrigger, [
  transition("* => " + SlideAnimationPageKey, [
    style({ position: "relative" }),
    query(
      ":enter, :leave",
      [
        style({
          position: "absolute",
          top: 0,
          width: "100%",
        }),
      ],
      { optional: true },
    ),
    query(":enter", [style({ transform: "translateX(100%)", opacity: 0 })], { optional: true }),
    group([
      query(
        ":leave",
        [animate("300ms ease-out", style({ transform: "translateX(-100%)", opacity: 0 }))],
        { optional: true },
      ),
      query(
        ":enter",
        [animate("300ms ease-out", style({ transform: "translateX(0)", opacity: 1 }))],
        { optional: true },
      ),
    ]),
  ]),
  transition(SlideAnimationPageKey + " => *", [
    style({ position: "relative" }),
    query(
      ":enter, :leave",
      [
        style({
          position: "absolute",
          top: 0,
          width: "100%",
        }),
      ],
      { optional: true },
    ),
    query(":enter", [style({ transform: "translateX(-100%)", opacity: 0 })], { optional: true }),
    group([
      query(
        ":leave",
        [animate("300ms ease-out", style({ transform: "translateX(100%)", opacity: 0 }))],
        { optional: true },
      ),
      query(
        ":enter",
        [animate("300ms ease-out", style({ transform: "translateX(0)", opacity: 1 }))],
        { optional: true },
      ),
    ]),
  ]),
]);
